module.exports = __webpack_public_path__ + "static/media/hourglass-ended_color_big.f5658055.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/hourglass-ended_color_big.png
// module id = ./src/assets/media/icons/hourglass-ended_color_big.png
// module chunks = 16